import { DateFormats, TimeFormats } from '@uplift/constants';
import { CalendarDateService, DateObject, DateObjectDiffUnit, DateObjectInput } from '../calendar-date-serivce/calendar-date-service';

const getDate = (
  date,
  days = 0,
  format = DateFormats['yyyy-MM-DD'],
  keepLocalTime = true
) => {
  return CalendarDateService.date(date)
    .utc(keepLocalTime)
    .add(days, DateFormats.days)
    .format(format);
};

const getTime = (date, format = TimeFormats['h:mm'], isLocalTime?: boolean) => {
  return CalendarDateService.date(date).utc(isLocalTime).format(format);
};

const getDuration = (
  startDate: DateObjectInput,
  endDate: DateObjectInput,
  format: DateObjectDiffUnit = 'minutes'
) => {
  const nowTime = CalendarDateService.date.utc(endDate);
  const startTime = CalendarDateService.date.utc(startDate);

  return nowTime.diff(startTime, format);
};

export const isInPastByMonth = (date: DateObject) => {
  return date.isBefore(CalendarDateService.date(), 'month');
};
export const isExceedingByMonth = (date: DateObject, months: number) => {
  return date.isAfter(CalendarDateService.date().add(months, 'month'), 'month');
};

export const utcToLocalTime = (time: Date | string) => CalendarDateService.date.utc(time).local();

export const getLocalTime = (time: Date | string, format: string) =>
  utcToLocalTime(time).format(format);

export const LegacyDateTimeService = {
  getLocalTime,
  getDate,
  getTime,
  getDuration,
  utcToLocalTime,
};
